import { toast } from 'react-toastify';

function ensureMessageString(input) {
    if (input == null) return ' ';
    if (typeof input === 'string') return input || ' ';
    if (typeof input === 'object') {
        const candidates = [
            input.message, 
            input.error, 
            input.detail, 
            input.description,
            input.details,
            input.payload?.message,
            input.payload?.error
        ];
        const first = candidates.find((v) => typeof v === 'string' && v.trim().length);
        if (first) return first;
        
        if (input.code && input.message) {
            return `${input.message} (Code: ${input.code})`;
        }
        
        try { 
            return JSON.stringify(input); 
        } catch (e) { 
            return String(input); 
        }
    }
    return String(input);
}

function fallbackByType(type) {
    switch (type) {
        case 'error':
            return 'Error';
        case 'warning':
            return 'Warning';
        case 'info':
            return 'Info';
        case 'success':
        default:
            return 'Success';
    }
}

const defaultOptions = {
    autoClose: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    hideProgressBar: false,
};

const CustomNotify = (message = '', type = 'success', params = {}) => {
    let formattedMessage = ensureMessageString(message);
    if (!formattedMessage || !String(formattedMessage).trim()) {
        formattedMessage = fallbackByType(type);
    }
    const opts = { ...defaultOptions, ...(params || {}) };

    switch (type) {
        case 'error':
            return toast.error(formattedMessage, opts);
        case 'info':
            return toast.info(formattedMessage, opts);
        case 'warning':
            return toast.warning(formattedMessage, opts);
        case 'success':
        default:
            return toast.success(formattedMessage, opts);
    }
};

export default CustomNotify;
